export const SERVICE_PROVIDER_OPTIONS = [
  { value: 'VODA', option: 'Vodafone' },
  { value: 'TMOB', option: 'T-Mobile' },
  { value: 'E+', option: 'E-Plus' },
  { value: 'BASE', option: 'BASE' },
  { value: 'SIMYO', option: 'Simyo' },
  { value: 'O2', option: 'O2 Germany' },
  { value: 'MC', option: 'Mobilcom' },
  { value: 'MCD', option: 'Mobilcom debitel' },
  { value: 'FN', option: 'Freenet' },
  { value: 'TALKL', option: 'Talkline' },
  { value: 'DEBIT', option: 'Debitel' },
  { value: 'CONGS', option: 'Congstar' },
  { value: 'FONIC', option: 'Fonic' },
  { value: 'TCHIB', option: 'Tchibo Mobil' },
];

export const SERVICE_PROVIDER_OPTIONS_WITHOUT_FONIC_TCHIB =
  SERVICE_PROVIDER_OPTIONS.filter(
    (option) => option.value !== 'FONIC' && option.value !== 'TCHIB',
  );
